import React from 'react';
import { ContainerTexto, Title, TitleContainer, Text, Tags, FixedAnchor } from '../styles';
import tabela from '../../../assets/img/ajuda/tabela.svg';
import { Anchor } from 'antd';

const Atendimento: React.FC = () => {

  const { Link } = Anchor

  return (
    <>
      <ContainerTexto>
        <TitleContainer id="atendimento-inicio">Atendimento</TitleContainer>
        <Text>
          Em “Atendimento” o usuário poderá consultar e exportar seus atendimentos. Ele poderá ver
          todas as suas ocorrências e acompanhar os retornos dos atendimentos.
        </Text>

        <Title id="atendimento-info">Informações Principais</Title>
        <Text>
          O usuário poderá incluir um novo atendimento clicando em “Nova Ocorrência”. Os campos com
          preenchimentos obrigatórios são:
        </Text>
        <Tags>
          <div>CD responsável pela distribuição</div>
          <div>Tipo de solicitação</div>
          <div>Classificação de urgência</div>
          <div>Assunto</div>
        </Tags>
        <Text>
          Caso o tipo de solicitação exija nota, deverá ser obrigatório vincular a nota ao
          atendimento através do botão “Adicionar nota”.{' '}
        </Text>
        <img src={tabela} alt="imagem mostrando os tipos de atendimento" />

        <Text>
          Será exibido uma nova janela com as notas vinculadas ao campo “Cliente final (Parceiro)”.
          O usuário pode utilizar os campos “Número da nota” e “Período de emissão” para filtrar as
          informações. O atendimento pode ter mais de uma nota vinculada a ele caso necessário,
          basta clicar no botão "Selecionar” e repetir o processo.{' '}
        </Text>

        <Text>
          Caso a nota não seja localizada, poderá ser feita a inclusão manual da nota clicando em
          “Adicionar nota manualmente”. O usuário deverá preencher os campos obrigatórios:
        </Text>

        <Tags>
          <div>N° da nota</div>
          <div>Remetente</div>
          <div>Cidade Remetente/UF</div>
          <div>Destinatário</div>
          <div>Cidade destinatário/UF </div>
        </Tags>

        <Text>
          Após informar os campos o usuário deve clicar no botão "Adicionar Nota”. As notas
          inseridas manualmente terão a coluna “Inserção manual” preenchida com “Sim”.{' '}
        </Text>

        <Text>
          É obrigatório o preenchimento do campo “Descrição do atendimento/Ocorrência”, onde a
          situação deverá ser relatada com o máximo detalhes possível para melhor compreensão do
          atendente.
        </Text>

        <Text>
          Também é possível adicionar anexos ao atendimento, com uma limitação de 5 MB por arquivo,
          nos formatos .pdf, .xls, .png, .jpg, .doc, .rar, .xml.
        </Text>

        <Text>
          Após o preenchimento das informações, para salvar o atendimento será necessário clicar em
          “Cadastrar” para finalizar a inclusão.{' '}
        </Text>

        <Text>
          Observações: Caso o usuário deseje cancelar a inclusão, deverá clicar em “Cancelar”, mas
          se caso deseje apenas minimizar a abertura do atendimento, para continuar preenchendo as
          informações posteriormente, o atendimento deverá ser fechado no "X" posicionada no canto
          superior direito do modal.
        </Text>

        <Title id="atendimento-acompanhamento">Acompanhamento do atendimento</Title>

        <Text>
          Após a inclusão, será encaminhado um email automaticamente com as informações preenchidas
          na abertura do atendimento para o e-mail vinculado ao parceiro solicitante.{' '}
        </Text>

        <Text>
          O acompanhamento pode ser feito através do e-mail cadastrado ou pelo módulo de atendimento
          da Kothe Log.{' '}
        </Text>

        <Text>
          O usuário poderá visualizar os detalhes do atendimento através da coluna “Ver ocorrência”,
          presente na grid do módulo de “Atendimentos”. É possível acompanhar o histórico de
          mensagens e interações, assim como enviar mensagens e anexos para o atendente. Também é
          possível visualizar as informações inseridas na abertura do atendimento na seção “Detalhes
          do atendimento”.
        </Text>

        <Title id="atendimento-finRer">Finalização e Reabertura do atendimento</Title>

        <Text>
          Ao fim do atendimento, o atendente mudará o status para “Finalizado”, com isso o usuário
          não poderá realizar nenhum tipo de interação, como o envio de mensagens.{' '}
        </Text>

        <Text>
          Caso o usuário queira dar continuidade ao atendimento, é possível reabri-lo através do
          botão “Reabrir atendimento” disponível tanto na grid principal através da coluna “Ações”
          quanto pela tela de Atendimento que pode ser acessada pela coluna “Ver ocorrência”.{' '}
        </Text>
        <Text>A opção está localizada no canto superior direito.</Text>
      </ContainerTexto>

      <FixedAnchor>
        <Link title="Início" href='#atendimento-inicio' />
        <Link title="Informações Principais" href='#atendimento-info' />
        <Link title="Acompanhamento do atendimento" href='#atendimento-acompanhamento' />
        <Link title="Finalização e Reabertura do atendimento" href='#atendimento-finRer' />
      </FixedAnchor>
    </>
  );
};

export default Atendimento;
